export const ALL_POSTS_CATEGORY_ID = 'all-posts';

export const isAllPostsCategory = (category: { id?: string } | null | undefined) =>
  category?.id === ALL_POSTS_CATEGORY_ID;
